import React, {useState, useEffect} from 'react';
import Image from "../banner.jpg";
import axios from 'axios';
import {Grid } from  'react-loader-spinner';




function Banner() {

  const [movie, setMovie] = useState({});

    useEffect(function(){
        axios.get("https://api.themoviedb.org/3/trending/movie/week?api_key=ea1c463be08abb857662aa8bef37a004&page=1")
        .then((res)=>{
            setMovie(res.data.results[0]);
        })

    },[])

    // console.log("printing movies");
    // console.log(movies[0].title);

  return(
    <div className=
      {`bg-[url(${`http://image.tmdb.org/t/p/original/${movie.backdrop_path}`})] h-[40vh] md:h-[60vh]
          bg-center bg-cover flex items-end
      `}>
          <div className='text-xl md:text-3xl text-white p-4 bg-gray-900 bg-opacity-50 w-full flex justify-center'>
              {movie.title}</div>
    </div>
  );
}

export default Banner;
